<div class="modal common-right-modal provider-modal show" style="display: block;" role="dialog" id="payer-details"  [ngClass]="{'show':showSlider}" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
    <div class="modal-dialog modal-large ">
        <div class="modal-content">
            <div class="modal-header">
                <div class="title-head d-flex align-items-center">
                    <button id="btnAddGroupClose" type="button" class="btn-close tool-wrap position-relative" data-bs-dismiss="modal"
                    (click)="closePopup()" aria-label="Close">
                    <div class="custom-tooltip tooltip-top" role="tooltip">
                        <div class="arrow"></div>
                        <div class="tooltip-inner"> Close </div>
                      </div></button>
                    <h2 class="modal-title" id="exampleModalToggleLabel">Payer Details
                    </h2>
                </div>
                <div class="btn-wrap">
                    <button type="button" class="btn-text edit" data-bs-toggle="modal" *ngIf = "showEdit" (click)="showEditPopup();">Edit Details</button>
                </div>
            </div>
            <div class="modal-body insurance-modal">
                <div class="inner-loader-wraper" *ngIf="isLoader">
                    <div class="inner-loader"></div>
                </div>
                <ng-container *ngIf="!isLoader">
                <div class="row-item mb-2">
                    <div class="form-heading mb-3">
                        <h3 class="before-none flex-border"><span>Company Details</span>
                            <div class="heading-border"></div>
                        </h3>
                        <ng-container *ngIf="detailsList?.tpaPayers?.length">
                            <span class="sm-text"><img src="assets/images/icons/tick.svg" alt="tick icon">Third Party Adjudicator</span>
                        </ng-container>
                    </div>
                    <div class="row">
                        <div class="col-4 ">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Company Name</label></div>
                                <div class="col detail-view">
                                    <span class="pointer">-</span>{{detailsList?.payerName}}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Associated Country</label></div>
                                <div class="col detail-view">
                                    <span class="pointer">-</span>{{assCountryObjt?.countryName}}
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Payer Code</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.payerCode}}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Website</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.website}}</div>
                            </div>
                           
                        </div>
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Validity</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.validityStart | date:'MM/dd/yyyy'}} - {{detailsList?.validityEnd | date:'MM/dd/yyyy'}}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Currency</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{currencyObj?.currencyDesc || 'Nill'}}</div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Description</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.description || '-'}} </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row-item mb-2">
                    <div class="form-heading mb-3">
                        <h3 class="before-none flex-border"><span>Address</span>
                            <div class="heading-border"></div>
                        </h3>
                    </div>
                    <div class="row">
                        <div class="col-4 ">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Country</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{countryObjt?.countryName}}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Area Code</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.areaCode || 'Nill'}}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Street Name</label></div>
                                <div class="col detail-view"><span class="pointer">-</span>{{detailsList?.streetName || 'Nill'}}</div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">State / Region</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{stateObjt?.regionName || 'Nill'}}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Geo Code</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.geocode || 'Nill'}}</div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Area</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.areaName}}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Building Name</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.buildingName || 'Nill'}}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row-item mb-2">
                    <div class="form-heading mb-3">
                        <h3 class="before-none flex-border"><span>Contact Details</span>
                            <div class="heading-border"></div>
                        </h3>
                    </div>
                    <ng-container *ngIf="detailsList?.contactPerson">
                    <div class="row" *ngFor="let contact of detailsList?.contactPerson; last as last">
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">First Name</label></div>
                                <div class="col detail-view">
                                    <span class="pointer">-</span>{{contact?.contactPersonFname}}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Role</label></div>
                                <div class="col detail-view">
                                    <span class="pointer">-</span>{{contact?.roles.length ? contact?.roles[0]?.name:"NA"}}
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Middle Name</label></div>
                                <div class="col detail-view">
                                    <span class="pointer">-</span>{{contact?.contactPersonMname}}
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Contact No.</label></div>
                                <div class="col detail-view">
                                    <span class="pointer">-</span>{{contact?.countryPhoneCode?.[0]?.phoneCode}} {{contact?.contactPhone}}
                                </div>
                            </div>    
                        </div>
                        <div class="col-4">
                            
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Last Name</label></div>
                                <div class="col detail-view">
                                    <span class="pointer">-</span>{{contact?.contactPersonLname}}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Contact Email</label></div>
                                <div class="col detail-view">
                                    <span class="pointer">-</span>{{contact?.contactEmail}}
                                </div>
                            </div>
                        </div>
                        <div class="row-item mb-2">
                            <div class="form-heading form-sub-head mb-3">
                                <h3 class="before-none flex-border"><span>User</span>
                                    <div class="heading-border "></div>
                                </h3>
                            </div>
                            <div class="row">
                                <div class="col-4 ">
                                    <div class="row mb-2">
                                        <div class="col-5"><label class="form-label">Username</label></div>
                                        <div class="col detail-view"> <span class="pointer">-</span>{{contact?.username ? contact?.username : 'Nill'}}</div>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="row">
                                        <div class="col-5"><label class="form-label">Password</label></div>
                                        <div class="col detail-view"> <span class="pointer">-</span>{{contact?.password ? '*********' : 'Nill'}}</div>
                                    </div>
                                </div>
                                <div class="col-12" *ngIf="!last">
                                    <hr class="doted mt-1"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    </ng-container>
                </div>
            
                <div class="row-item mb-1">
                    <div class="form-heading mb-3">
                        <h3 class="before-none flex-border"><span>Regulator</span>
                            <div class="heading-border"></div>
                        </h3>
                    </div>
                    <div class="row">
                        <div class="col-3 ">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Country</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{countryRegObjt?.countryName}}</div>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Regulator</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{regulatorObjt?.regulatoryAuthority}}</div>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Receiver ID</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.credentials?.[0]?.receiverId}}</div>
                            </div>
                            </div>
                            <div class="col-3">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Payer ID</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.credentials?.[0]?.payerRegReferenceId}}</div>
                            </div>
                        </div>
                    </div>
                </div>

                
                <div class="row-item mb-1">
                    <div class="form-heading mb-3">
                        <h3 class="before-none flex-border"><span>Client Credentials</span>
                            <div class="heading-border"></div>
                        </h3>
                    </div>
                    <div class="row">
                        <div class="col-4 ">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Client ID</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.client_id || 'Nill'}}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Validity</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.clientValidityStart | date:'MM/dd/yyyy'}} - {{detailsList?.clientValidityEnd | date:'MM/dd/yyyy'}}</div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Client Secret</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{clientSecretMasked || 'Nill'}}</div>
                                <a  class="copy-icon tool-wrap position-relative" (click)="copyMessage(detailsList?.client_secret)">
                                    <div class="custom-tooltip tooltip-top" role="tooltip">
                                        <div class="arrow"></div>
                                        <div class="tooltip-inner"> {{copyText}} </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">URL</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.url}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row-item mb-1" *ngIf="detailsList?.tpaPayers?.length">
                    <div class="col-12">
                        <div class="tariff-form mb-3">
                            <div class="row">
                               <div class="col-12">
                                <div class="tab-section">
                                   
                                    <ul class="nav nav-tabs" role="tablist" id="moving-tabs">
                                        <div class="slider" style="left: 0px; width: 90.9688px;"></div>
                                        <li class="nav-item" role="presentation"  *ngFor="let tpa of detailsList?.tpaPayers;let i=index">
                                            <a class="nav-link" [ngClass]="{active: i===currentCompany}"  (click)="currentCompany=i;" id="CDetails-tabView" data-bs-toggle="tab" data-bs-target="#CDetailsView" role="tab" aria-controls="home" aria-selected="true">{{tpa?.payerName}}</a>
                                        </li>
                                        
                                        <div class="right-area-tab d-flex align-items-center">
                                        <div class="scroll-buttons">
                                            <a  class="scroll-left" [ngClass]="{'disabled':currentCompany === 0}"  (click)="shift(true,false)" ></a>
                                            <a  class="scroll-right"[ngClass]="{'disabled':currentCompany === detailsList?.tpaPayers - 1}"  (click)="shift(false,true)"></a>
                                        </div>
                                        </div>
                                    </ul>                
                                    <div class="tab-content" id="myTabContent">
                                        <div class="tab-pane with-scroll fade active show" id="CDetailsView" role="tabpanel" aria-labelledby="CDetails-tabView">
                                            <div class="row mt-2">
                                                <div class="col-4 ">
                                                    <div class="row mb-2">
                                                        <div class="col-5"><label class="form-label">Company Name</label></div>
                                                        <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.payerName}}</div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-5"><label class="form-label">Associated Country</label></div>
                                                        <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.assocCountryName}}</div>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="row mb-2">
                                                        <div class="col-5"><label class="form-label">Website</label></div>
                                                        <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.website}}</div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-5"><label class="form-label">Status</label></div>
                                                        <div class="col detail-view"> <span class="pointer">-</span>Approve</div>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="row mb-2">
                                                        <div class="col-5"><label class="form-label">Currency</label></div>
                                                        <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.currLabel}}</div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-5"><label class="form-label">Description</label></div>
                                                        <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.description || 'Nill'}}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row-item">
                                                <div class="form-heading mb-3">
                                                    <h3 class="before-none flex-border"><span>Contact Details</span>
                                                        <div class="heading-border"></div>
                                                    </h3>
                                                </div>
                                                <ng-container *ngIf="detailsList?.tpaPayers[currentCompany]?.contactPerson">
                                                    <div class="row" *ngFor="let contact1 of detailsList?.tpaPayers[currentCompany]?.contactPerson; last as last">
                                                    <div class="col-4 ">
                                                        <div class="row">
                                                            <div class="col-5"><label class="form-label">First Name</label></div>
                                                            <div class="col detail-view"> <span class="pointer">-</span>{{contact1?.contactPersonFname}}</div>
                                                        </div>
                                                      
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="row">
                                                            <div class="col-5"><label class="form-label">Contact No.</label></div>
                                                            <div class="col detail-view"> <span class="pointer">-</span>{{contact1?.countryPhoneCode?.[0]?.phoneCode}} {{contact1?.contactPhone}}</div>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="row">
                                                            <div class="col-5"><label class="form-label">Contact Email</label></div>
                                                            <div class="col detail-view"> <span class="pointer">-</span>{{contact1?.contactEmail}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                </ng-container>
                                            </div>

                                            <div class="row-item">
                                                <div class="form-heading mb-3">
                                                    <h3 class="before-none flex-border"><span>Address</span>
                                                        <div class="heading-border"></div>
                                                    </h3>
                                                </div>
                                                <div class="row">
                                                    <div class="col-4 ">
                                                        <div class="row mb-2">
                                                            <div class="col-5"><label class="form-label">Country</label></div>
                                                            <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.countryName}}</div>
                                                        </div>
                                                        <div class="row mb-2">
                                                            <div class="col-5"><label class="form-label">Area Code</label></div>
                                                            <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.areaCode}}</div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-5"><label class="form-label">Street Name</label></div>
                                                            <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.streetName || 'Nill'}}</div>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="row mb-2">
                                                            <div class="col-5"><label class="form-label">State / Region</label></div>
                                                            <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.regionName}}</div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-5"><label class="form-label">Geo Code</label></div>
                                                            <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.geoCode || 'Nill'}}</div>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="row mb-2">
                                                            <div class="col-5"><label class="form-label">Area</label></div>
                                                            <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.areaName || 'Nill'}}</div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-5"><label class="form-label">Building Name</label></div>
                                                            <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.buildingName || 'Nill'}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row-item">
                                                <div class="form-heading mb-3">
                                                    <h3 class="before-none flex-border"><span>Regulator</span>
                                                        <div class="heading-border"></div>
                                                    </h3>
                                                </div>
                                                <div class="row">
                                                    <div class="col-4">
                                                        <div class="row">
                                                            <div class="col-5"><label class="form-label">Country</label></div>
                                                            <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.credentials?.[0]?.countryObjt?.[0]?.countryName}}</div>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="row">
                                                            <div class="col-5"><label class="form-label">Regulator</label></div>
                                                            <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.tparegLabel}}</div>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="row">
                                                            <div class="col-5"><label class="form-label">Payer ID</label></div>
                                                            <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.credentials?.[0]?.payerRegReferenceId}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                    
                                            <div class="row-item">
                                                <div class="form-heading mb-3">
                                                    <h3 class="before-none flex-border"><span>Client Credentials</span>
                                                        <div class="heading-border"></div>
                                                    </h3>
                                                </div>
                                                <div class="row">
                                                    <div class="col-4">
                                                        <div class="row mb-2">
                                                            <div class="col-5"><label class="form-label">Client ID</label></div>
                                                            <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.client_id || 'Nill'}}</div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-5"><label class="form-label">Validity</label></div>
                                                            <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.clientValidityStart | date:'MM/dd/yyyy'}} - {{detailsList?.tpaPayers[currentCompany]?.clientValidityEnd | date:'MM/dd/yyyy'}}</div>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="row mb-2">
                                                            <div class="col-5"><label class="form-label">Client Secret</label></div>
                                                            <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.client_secret || 'Nill'}}</div>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="row">
                                                            <div class="col-5"><label class="form-label">URL</label></div>
                                                            <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.tpaPayers[currentCompany]?.url}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                               </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row-item mb-1" *ngIf="detailsList?.payerCapIntegration.length" >
                    <div class="form-heading mb-3">
                        <h3 class="before-none flex-border"><span>Cap Integration</span>
                            <div class="heading-border"></div>
                        </h3>
                    </div>
                    <div class="row">
                        <div class="col-4 " *ngIf="detailsList.payerCapIntegration[0].typeOfApi">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Type of Api</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList.payerCapIntegration[0].typeOfApi || 'Nill'}}</div>
                            </div>
                        </div>
                        <div class="col-4 " *ngIf="detailsList.payerCapIntegration[0].endpoint">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">End Point</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList.payerCapIntegration[0].endpoint || 'Nill'}}</div>
                            </div>
                        </div>
                        <div class="col-4" *ngIf="detailsList.payerCapIntegration[0].method">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Method</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList.payerCapIntegration[0].method || 'Nill'}}</div>
                            </div>
                        </div>
                        <div class="col-4" *ngIf="detailsList.payerCapIntegration[0].typeOfAuthorization">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Type of authorization</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList.payerCapIntegration[0].typeOfAuthorization || 'Nill'}}</div>
                            </div>
                        </div>
                        <div class="col-4" *ngIf="detailsList.payerCapIntegration[0].clientId">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Client Id</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList.payerCapIntegration[0].clientId || 'Nill'}}</div>
                            </div>
                        </div>
                        <div class="col-4" *ngIf="detailsList.payerCapIntegration[0].clientSecret">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Client Secret</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList.payerCapIntegration[0].clientSecret || 'Nill'}}</div>
                            </div>
                        </div>
                        <div class="col-4" *ngIf="detailsList.payerCapIntegration[0].redirectUri">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Redirect Uri</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList.payerCapIntegration[0].redirectUri || 'Nill'}}</div>
                            </div>
                        </div>
                        <div class="col-4" *ngIf="detailsList.payerCapIntegration[0].token">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Token</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList.payerCapIntegration[0].token || 'Nill'}}</div>
                            </div>
                        </div>
                        <div class="col-4" *ngIf="detailsList.payerCapIntegration[0].activeToEnd">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Validity</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList.payerCapIntegration[0].activeToEnd || 'Nill'}}</div>
                            </div>
                        </div>
                        <div class="col-12" *ngIf="detailsList.payerCapIntegration[0].requestPayloadSchema">
                            <div class="json-wrap  mb-2" [class.opened]="preBlock">
                                <div class=""><label class="form-label"><span class="relative-head">Request Payload Schema<span class="cs-arrow-down"  (click)="preBlock = !preBlock"></span></span></label></div>
                                <div class="json-wrap-item fade-in-main" *ngIf="preBlock">
                                    <pre>{{detailsList.payerCapIntegration[0].requestPayloadSchema}}</pre>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            </div>
        </div>
    </div>
</div>


